import { render } from "./DisclaimerAndAssumptions.vue?vue&type=template&id=77cd76f1"
import script from "./DisclaimerAndAssumptions.vue?vue&type=script&lang=js"
export * from "./DisclaimerAndAssumptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__